module.exports = __webpack_public_path__ + "img/md-tr.58fa75df.svg";